import React, { useState } from "react";
import { allSharedComponents } from "../../../shared";
import CustomModal from "../../../shared/components/CustomModal/CustomModal";
import { Button } from "react-bootstrap";
import NavBar from "../../../shared/components/NavBar/NavBar";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { translationConstants, viewPathConstants } from "../../../constants";

const ForgotPassword = () => {
  const { GeneralLogo, DontHaveAAccount, ForgotPassword, BaseForm } =
    allSharedComponents;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toRegisteration = () => {
    navigate(viewPathConstants.REGISTRATION);
  };
  const toLogin = () => {
    navigate(viewPathConstants.DEFAULT_PATH);
  };
  const [isShow, setShow] = useState(true);
  const onSetShow = () => {
    setShow(false);
  };
  return (
    <>
      <div className="background-image ForgotContainer">
        <CustomModal
          size="sm"
          scrollable={true}
          setShow={onSetShow}
          show={isShow}
          closeBtnClasses={"login-modal-close-btn"}
          isMoveBack={true}
        >
          <BaseForm>
            <GeneralLogo />
            <ForgotPassword />
            <DontHaveAAccount />
          </BaseForm>
        </CustomModal>
      </div>
    </>
  );
};

export default ForgotPassword;
